export default "__VITE_ASSET__C3WvHp9r__"